import * as Dialog from '@radix-ui/react-dialog'
import { AlertTriangle, Search, Settings } from 'lucide-react'

interface WelcomeModalProps {
  open: boolean
  onContinue: () => void
}

export function WelcomeModal({ open, onContinue }: WelcomeModalProps) {
  return (
    <Dialog.Root open={open}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[95vw] max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-border bg-card p-8 shadow-2xl data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95">
          {/* Title */}
          <Dialog.Title className="text-2xl font-bold text-foreground text-center mb-3">
            Seja bem-vindo!
          </Dialog.Title>

          {/* Description */}
          <Dialog.Description className="text-sm text-muted-foreground text-center mb-8 leading-relaxed">
            Para começarmos sua Gestão Profissional, iremos desenvolver um planejamento personalizado de acordo com seu{' '}
            <span className="font-semibold text-foreground">Perfil de risco</span>.
          </Dialog.Description>

          {/* Illustration */}
          <div className="flex justify-center mb-8">
            <div className="relative w-40 h-40">
              {/* Alert Triangle */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2">
                <div className="w-16 h-16 rounded-lg border-2 border-muted-foreground/30 flex items-center justify-center bg-card">
                  <AlertTriangle className="w-8 h-8 text-muted-foreground/60" strokeWidth={1.5} />
                </div>
              </div>

              {/* Settings/Gear */}
              <div className="absolute bottom-4 left-4">
                <div className="w-14 h-14 rounded-lg border-2 border-muted-foreground/30 flex items-center justify-center bg-card">
                  <Settings className="w-7 h-7 text-muted-foreground/60" strokeWidth={1.5} />
                </div>
              </div>

              {/* Magnifying Glass */}
              <div className="absolute bottom-0 right-4">
                <div className="w-16 h-16 rounded-lg border-2 border-muted-foreground/30 flex items-center justify-center bg-card">
                  <Search className="w-8 h-8 text-muted-foreground/60" strokeWidth={1.5} />
                </div>
              </div>

              {/* Connecting lines (decorative) */}
              <svg
                className="absolute inset-0 w-full h-full pointer-events-none"
                viewBox="0 0 160 160"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M80 64 L56 96 M80 64 L104 96"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeDasharray="4 4"
                  className="text-muted-foreground/20"
                />
              </svg>
            </div>
          </div>

          {/* CTA Button */}
          <button
            onClick={onContinue}
            className="w-full py-3 px-6 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-base hover:from-blue-600 hover:to-blue-700 transition-all duration-200 shadow-lg shadow-blue-500/25"
          >
            Clique aqui
          </button>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
